<template>
  <ur-modal ref="modal" :title="'대화 상세정보'" width="944px" height="758px">
    <!-- <div class="modal"> -->
      <!-- <div class="modal_dialog"> -->
        <div class="modal_content modal_lg detail_scenario_pop">
          <div class="modal_body">
            <div class="box_gray">
              <dl>
                <dd><strong>대화ID</strong>{{scriptDetail.scriptId}}</dd>
                <dd><strong>시스템코드</strong>{{scriptDetail.managedScriptId}}</dd>
                <dd><strong>요청일자</strong>{{changeDateformat(scenarioInfo.fstRgstDtm)}}</dd>
                <dd><strong>완료일자</strong>{{changeDateformat(scenarioInfo.completionDate) || '미완료&ensp;&ensp;&ensp;&ensp;&ensp;'}}</dd>
              </dl>
            </div>
          </div>
        </div>
        <div class="tbl_list type2" style="overflow-y:auto; height:600px; margin-top: 14px;">
          <table>
            <colgroup>
              <col style="width: 166px">
              <col style="width: auto">
            </colgroup>
            <tr>
              <th scope="row">발화조건</th>
              <td>{{scriptDetail.speechConditionName}}</td>
            </tr>
            <tr>
              <th scope="row">발화그룹</th>
              <td>{{scriptDetail.scriptGroupName}}</td>
            </tr>
            <tr>
              <th scope="row">AI 발화문장</th>
              <td>
                <div>
                  <aicc-text-area ref="script" rows="7" style="width:660px; font-size: 14px;" v-model="scriptDetail.script" :readonly="modifyLock" :counter="scriptMaxLength" :rules="validateRule" />
                </div>
                <div class="hbox jc" style="margin-top:5px">
                  <p class="txt_desc" style="display:inline-block; color:#516af4; font-size: 12px;" v-if="!modifyLock&&validateVariable()">* AI 발화문장을 수정한 이후에는 이전으로 복구가 불가합니다. 수정 전 데이터 다운로드를 권장합니다.</p>
                  <p class="txt_desc" style="display:inline-block; color:#ff5858; font-size: 12px;" v-if="!editable&&scenarioInfo.statusCode === 'D'">* [작성중/대기중/진행중/중지] 상태인 캠페인에 현재 시나리오가 등록되어 있어서 발화문장 수정이 불가합니다.</p>
                  <p class="txt_desc" style="display:inline-block; color:#ff5858; font-size: 12px;" v-else-if="scenarioModifying.isModifying&&scenarioModifying.usrNm">* 현재 {{scenarioModifying.usrNm}}님이 수정중 상태인 시나리오로, 발화문장 수정이 불가합니다.</p>
                  <p class="txt_desc" style="display:inline-block; color:#ff5858; font-size: 12px;" v-if="!validateVariable()">올바르지 않은 변수 형식입니다. 작성된 변수를 다시 한번 확인해주세요.</p>
                  <ur-button shape="hyperlink" style="float:right; color:#516af4; font-size: 12px;" @click="onClickVariable()">변수 조회</ur-button>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">답변유형</th>
              <td>
                {{getAnswerType(scriptDetail.answerType) + getQuestionCategoryName(scriptDetail.questionCategoryName)}}
                <div class="data_tbl_list" v-if="answerList.length" style="margin-top: 12px;">
                  <table>
                    <colgroup>
                      <col style="width:81px">
                      <col style="width:80px">
                      <col style="width:auto">
                    </colgroup>
                    <thead>
                      <tr>
                        <th scope="col" style="text-align: center;">답변</th>
                        <th scope="col" style="text-align: center;">정답여부</th>
                        <th scope="col" class="tal">액션</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in answerList" :key="index">
                        <td style="text-align: center;">{{item.answerCategoryName}}</td>
                        <td style="text-align: center;">{{item.rightAnswerYn}}</td>
                        <td>{{getAnswerAction(item.answerAction)}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <template slot="action">
          <ur-button primary @click="close()" v-if="!modifyLock">취소</ur-button>
          <ur-button shape="solid" primary @click="onClickValidationCheck()" v-if="!modifyLock">완료</ur-button>
          <ur-button shape="solid" primary @click="close()" v-if="modifyLock">확인</ur-button>
        </template>
        <!-- 변수 조회 모달 -->
        <ur-modal ref="variableModal" :title="'변수 조회'" :width="703" :height="494" dragable>
          <variable-table style="margin-bottom:20px" :headers="variableHeaders" :items="variableItems" />
          <ur-button shape="hyperlink" style="z-index:1000; padding: 0 4px; color:#516af4;" @click="onClickVariableDownload()">변수목록 다운로드</ur-button>
          <div style="float:right">
            <ur-button shape="solid" primary style="z-index:1000" @click="closeVariableModal()">확인</ur-button>
          </div>
        </ur-modal>
        <!-- 미등록 변수 알림 모달 -->
        <ur-modal ref="confirmModal" :title="'알림'" small >
          <template>
            현재 시나리오에 등록되지 않은 변수가 발화문장에 포함되어 있습니다. 이대로 저장하시겠습니까?
          </template>
          <template slot="action">
            <ur-button primary @click="closeConfirmModal()" >취소</ur-button>
            <ur-button shape="solid" primary @click="onClickUpdateScript()" >확인</ur-button>
          </template>
        </ur-modal>
      <!-- </div> -->
    <!-- </div> -->
  </ur-modal>
</template>

<script>
import CMP_AID_00002 from './CMP_AID_00002';

export default {
  name: 'CMP_AID_00001', // eslint-disable-line vue/name-property-casing
  components: {
    variableTable: CMP_AID_00002,
  },
  props: {
    parentPageId: { type: String, required: true },
    scenarioId: { type: String, default: '' },
    scenarioInfo: { type: Object, default: () => {} },
    queries: { type: Array, default: () => [] },
    variableHeaders: { type: Array, default: () => [] },
    variableItems: { type: Array, default: () => [] },
    speechConditionItems: { type: Array, default: () => [] },
    scriptGroupCodeItems: { type: Array, default: () => [] },
    scenarioModifying: { type: Object, default: () => {} },
  },
  data() {
    return {
      // 스크립트
      scriptId: '',
      scriptDetail: {
        scriptId: '',
        managedScriptId: '',
        speechCondition: '',
        scriptGroupdCode: '',
        script: '',
        questionCategoryName: '',
        answerType: '',
      },
      answerList: [],
      editable: false,

      // 고객답변유형
      headers: [
        { text: '답변', value: 'answerCategoryName', width: '100px' },
        { text: '정답여부', value: 'rightAnswerYn', width: '100px' },
        { text: '예시', value: 'answerExample', width: '200px' },
      ],
      options: {
        noBaseInfo: true,
        infinityScroll: true,
        height: 200,
        rowHeight: 35,
      },

      // 변수 확인
      validRegex: /\{{2}\$([^{}]*)\}{2}/g, // '{{$'로 시작해서 '}}'로 끝나는 문자열을 올바른 변수 형식으로 판단. '{{$'와 '}}' 사이에는 '{', '}'가 올 수 없음
      invalidRegex: /[{}]/, // 변수를 제외한 문자열에 '{' 또는 '}'를 사용하면 올바르지 않은 변수 사용으로 판단.

      // validator
      validateRule: [
        (v) => this.validateVariable() || '',
        (v) => aiccUtils.getStringByteSize(this.scriptDetail.script) <= this.scriptMaxLength || `최대 ${this.scriptMaxLength}byte까지 입력 가능합니다.`,
      ],
      scriptMaxLength: 5000, // byte
      
      // 다운로드
      fileType: 'text/csv;charset=utf-8',
    };
  },
  computed: {
    variableDownloadData() {
      const headerIndexArr = [0, 1, 2];
      const dataString = aiccUtils.stringUtil.tableToCsvDataString(this.variableHeaders, this.variableItems, headerIndexArr);
      return dataString;
    },
    modifyLock() { // 시나리오 수정 제한 여부
      return !this.editable || this.scenarioModifying.isModifying;
    },
  },
  methods: {
    open(scriptId) {
      this.scriptId = scriptId;
      this.getScriptDetail();
      this.$refs.modal.open();
    },
    close() {
      this.$refs.modal.close();
      this.$emit('close');
    },

    // 스크립트 상세조회
    getScriptDetail() {
      const scriptAsk = {
        scenarioId: this.scenarioId,
        scriptId: this.scriptId,
      };
      http.request(this.parentPageId, 'DTS_AID_00010', {
        data: scriptAsk,
      }).then(res => {
        this.scriptDetail = res.data.script;
        this.answerList = res.data.answerList;
        this.editable = res.data.editable;
      });
    },

    // 고객답변유형 코드 -> 텍스트
    getAnswerType(answerType) {
      return aiccCode.answerType.codeText(answerType);
    },

    // 답변유형별 액션 코드 -> 텍스트
    getAnswerAction(answerAction) {
      return aiccCode.scenarioAnswerActionCode.codeText(answerAction);
    },
    
    // 일자 형식 YYYYMMDD -> YYYY-MM-DD
    changeDateformat(date) {
      return utils.dateformatToClient(date, 'S');
    },

    // 질문유형
    getQuestionCategoryName(questionCategoryName) {
      if (questionCategoryName) {
        return `(${questionCategoryName})`;
      }
      return '';
    },

    // 스크립트 수정
    validateVariable() {
      let text = this.scriptDetail.script;
      text = text.replace(this.validRegex, ''); // 올바른 형식의 변수를 제거한 뒤

      return !this.invalidRegex.test(text); // 문자열에 '{' 또는 '}'이 남아 있으면 올바르지 않은 변수 사용으로 판단
    },
    containsUndefinedVariable() {
      let text = this.scriptDetail.script;
      for (var item in this.queries) {
        text = text.split(this.queries[item]).join(''); // 등록된 변수를 제거한 뒤
      }

      return this.validRegex.test(text); // 문자열에 변수 형식이 남아 있으면 미등록 변수 사용으로 판단
    },
    onClickValidationCheck() {
      if (!this.$refs.script.isValid()) {
        return;
      }
      if (this.validateVariable()) {
        if (this.containsUndefinedVariable()) {
          this.$refs.confirmModal.open();
        } else {
          this.onClickUpdateScript();
        }
      } else {
        this.$refs.script.focus();
      }
    },
    onClickUpdateScript() {
      this.$refs.confirmModal.close();
      const scriptAsk = {
        scenarioId: this.scenarioId,
        scriptId: this.scriptId,
        script: this.scriptDetail.script,
      };
      http.request(this.parentPageId, 'DTS_AID_00011', {
        data: scriptAsk,
      }).then(res => {
        if (res.data.reply.code === '0000') {
          this.$emit('complete');
          this.close();
        } else {
          utils.aiccMessageBox('확인', res.data.reply.korMsg, '확인', null);
        }
      });
    },
    closeConfirmModal() {
      this.$refs.confirmModal.close();
    },

    // 변수조회    
    onClickVariable() {
      this.$refs.variableModal.open();
    },
    closeVariableModal() {
      this.$refs.variableModal.close();
    },

    // 다운로드
    onClickVariableDownload() {
      const url = aiccUtils.fileDownload.getBlobUrl(this.variableDownloadData, this.fileType);
      const fileName = `${this.scenarioInfo.scenarioName}_변수목록.csv`;
      const fileDownloadHistoryAsk = {
        pageId: this.parentPageId,
        fileName: fileName,
        fileDetail: `Scenario ID : ${this.scenarioId}`,
      };

      http.request(this.parentPageId, 'DTS_AIZ_00001', {
        data: fileDownloadHistoryAsk,
      }).then(res => {
        if (res.status === 200) {
          aiccUtils.fileDownload.download(url, fileName);
        } else {
          utils.aiccMessageBox('알림', '잠시 후 다시 시도해주세요.', '확인', null);
        }
      }).catch(error => {
        console.warn(error);
      });
    },

    // textarea class
    textareaClass() {
      if (!this.editable) {
        return 'textarea readonly';
      }

      if (!this.validateVariable()) {
        return 'textarea error';
      }

      return 'textarea';
    },
  },
};
</script>

<style scoped>
/* 시나리오상세정보팝업 */
.detail_scenario_pop.modal_content.modal_lg .modal_header {margin-bottom:24px}
.detail_scenario_pop .box_gray {margin-top:0}
.detail_scenario_pop .box_gray dl {padding: 12px 32px; min-height: 50px;}
.detail_scenario_pop .box_gray dl dd {flex-grow: 0;}
.detail_scenario_pop .box_gray dl dd:nth-child(1) {margin-left:0}
.detail_scenario_pop .box_gray dl dd:nth-child(3) {margin-left: auto}
.detail_scenario_pop .box_gray dl dd strong {display:inline-block; margin-right: 8px}
.detail_scenario_pop .tbl_list.type2 {margin-top: 20px}
.detail_scenario_pop .tbl_list.type2 th {padding: 4px}
.detail_scenario_pop .tbl_list.type2 td {padding: 4px}
.detail_scenario_pop .tbl_list.type2 .data_tbl_list {width:289px; border-top: 1px solid #656b7e; margin-top:10px}
.detail_scenario_pop .tbl_list.type2 .data_tbl_list th {padding: 2px !important; height: 29px !important; text-align: center;}
.detail_scenario_pop .tbl_list.type2 .data_tbl_list td {padding: 0px 2px !important; height: 26px !important; text-align: center;}
.detail_scenario_pop .tbl_list.type2 > table tr:first-child th,
.detail_scenario_pop .tbl_list.type2 > table tr:first-child td {padding-top:0}

.detail_scenario_pop .hbox {margin-bottom: 12px}
.detail_scenario_pop .txt_desc {color:#516af4; margin-top:4px;}
.detail_scenario_pop .txt_desc + .layer_wrap {margin-top:4px; margin-left:auto}
.detail_scenario_pop .modal_body {overflow: initial !important; max-height: inherit !important;}
.detail_scenario_pop .modal_body > p {letter-spacing: -0.5px; word-break: keep-all; word-wrap: break-word;}
.detail_scenario_pop .btn_txt + .layer_pop {position: absolute; top:0; padding: 24px;right: 62px; height: 240px;z-index: 99; display: none;}
.detail_scenario_pop .btn_txt + .layer_pop .layer_header .close {right:0; top:0;}
.detail_scenario_pop .btn_txt + .layer_pop .layer_header {margin-bottom: 12px}
.detail_scenario_pop .btn_txt + .layer_pop .layer_title {font-size: 16px; line-height: 24px;}
.detail_scenario_pop .btn_txt + .layer_pop table th {font-size: 14px; padding: 0 !important;line-height: 20px;}
.detail_scenario_pop .btn_txt + .layer_pop table td {font-size: 14px; padding: 2px 0 !important;line-height: 16px; height: 24px;}
.detail_scenario_pop .btn_txt + .layer_pop table td {font-size: 14px; padding: 2px 0 !important;line-height: 16px; height: 24px;}
.detail_scenario_pop .btn_txt + .layer_pop .tbl_default + .tbl_default {margin-top:8px}

/* ========== Table 목록형 ========== */
table caption {display:none}
.tbl_list table {border: 0}
.tbl_list th {font-size: 14px; color:#333; border: 0; border-top: 1px solid #eaeaea; border-bottom: 1px solid #a5a5a5; padding: 4px 16px 5px; font-weight: 500; vertical-align: top;}
.tbl_list td {font-size: 14px; color:#333; border: 0; border-bottom: 1px solid #eaeaea; padding: 10px 16px 9px; vertical-align: top;}
.tbl_list tr:hover td { background-color: #f7f7f7;}
.tbl_list td.hbox {padding-top:0; padding-bottom:0; align-items: center; }

/* .tbl_list.type2 th {border: 0; padding: 16px 0 16px 32px; font-size: 16px;} */
.tbl_list.type2 th {border: 0; padding: 6px 0 0 32px; font-size: 16px; font-weight:bold;}
/* .tbl_list.type2 td {border: 0; padding: 16px 0; font-size: 16px; vertical-align: middle;} */
.tbl_list.type2 td {border: 0; padding: 6px 0; font-size: 16px; vertical-align: middle;}
.tbl_list.type2 tr:hover td { background-color: transparent;}
.tbl_list.type2 .hbox + .data_tbl_list {margin-top:32px}
.tbl_list.type2 .tbl_list.type2 th {padding-left: 0}
/* .tbl_list.type2 .data_tbl_list th {padding: 12px 0 12px 16px !important; font-size: 14px;} */
.tbl_list.type2 .data_tbl_list th {padding: 0 0 0 16px !important; height: 29px; font-size: 14px; font-weight:bold; border-top: 1px solid;}
/* .tbl_list.type2 .data_tbl_list td {padding: 8px 0 8px 16px !important; border-bottom: 1px solid #eaeaea !important; height: 48px; font-size: 14px;} */
.tbl_list.type2 .data_tbl_list td {padding: 0 0 0 16px !important; border-bottom: 1px solid #eaeaea !important; height: 26px; font-size: 14px;}

/* ========== Data Table 목록 ========== */
/* .sorting {background: url(../images/aicc/ic_arrow2.png) no-repeat 50% 50%; width:16px; height:16px; display:inline-block; font-size:0; line-height:0;vertical-align: middle;  margin-left: 4px;} */

.data_tbl_list table {border: 0}
.data_tbl_list table caption {display:none}
.data_tbl_list thead {border-bottom: 1px solid #dee1eb}
.data_tbl_list th {font-size: 14px; color:#333;border: 0; border-top: 1px solid #656b7e; /*border-bottom: 1px solid #dee1eb;*/ padding: 11px 0 12px 16px; height:47px; background-color: #f8f9fd; vertical-align: middle;} 
.data_tbl_list th.on {z-index: 1; color: #516af4;}


.data_tbl_list td {font-size: 14px; color:#333; border: 0; border-bottom: 1px solid #eaeaea; padding: 8px 0 8px 16px; height:48px; word-wrap: break-word;}
.data_tbl_list td.tit {font-size:16px;font-weight:700}
.data_tbl_list tr:hover td {background-color: rgba(81, 106, 244, 0.1);}
.data_tbl_list tr.selected td {background-color: rgba(81, 106, 244, 0.1);}
.data_tbl_list th.add_col {background-color: rgba(81, 106, 244, 0.1);}
.data_tbl_list td.add_col {position: relative; height:48px}
.data_tbl_list td.add_col:before {display:block; content:''; position: absolute; top:0; left:0; width:100%; height:48px; background-color: rgba(81, 106, 244, 0.1);}
.data_tbl_list th.tac,
.data_tbl_list td.tac {text-align: center; padding-left:8px ; padding-right:8px}
.data_tbl_list td.tar,
.data_tbl_list th.tar {text-align: right; padding-left:8px; padding-right:8px}
.data_tbl_list tr.fail td {background-color:rgba(149, 149, 149, 0.06)}
.data_tbl_list td.progress_wrap > div {overflow: auto; height: calc(100% + 17px);}
.data_tbl_list td.progress_wrap td {height:48px}
.data_tbl_list td.state {position: relative;}
.data_tbl_list td.state:before {display:block; content:''; width: 100%; height: 46px; background-color: rgba(247, 247, 247, 0.7); position: absolute; top:1px; left: 0;}
.data_tbl_list .menu_wrap {width: 24px}
/* .data_tbl_list .btn_more {display:inline-block; background: url(../images/aicc/ic_more.png) no-repeat 50% 50%; width:24px; height: 24px; font-size: 0; line-height: 0; margin-left: auto} */
.data_tbl_list .btn_more:hover {border-radius: 2px; background-color: rgba(0, 0, 0, 0.06);}
.data_tbl_list th .info_wrap {margin-left:2px}

.data_tbl_list .no_data {text-align: center; height: 100%; display: flex;justify-content: center;align-items: center; font-size: 20px;}
.data_tbl_list td.no_data {display:table-cell; height: 400px !important; padding: 8px 16px}
.data_tbl_list tr:hover td.no_data {background-color: #fff;}

/* ========== form ========== */
.textarea {width: 100%; vertical-align: top;}
/* .textarea.error, */
/* .textarea.error:focus {border-color:#ff5858} */
.textarea.error:focus {outline-color:#ff5858}
/* .textarea:focus {border-color:#516af4;} */
.textarea:focus {outline-color:#516af4;}
.textarea.readonly:focus {outline:none;}
</style>